var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6867 5.1787C11.64 5.17203 11.5934 5.17203 11.5467 5.1787C10.5134 5.14536 9.69336 4.2987 9.69336 3.2587C9.69336 2.1987 10.5534 1.33203 11.62 1.33203C12.68 1.33203 13.5467 2.19203 13.5467 3.2587C13.54 4.2987 12.72 5.14536 11.6867 5.1787Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8602 9.80027C13.1136 10.3003 12.0669 10.4869 11.1002 10.3603C11.3536 9.8136 11.4869 9.20694 11.4936 8.56694C11.4936 7.90027 11.3469 7.26694 11.0669 6.7136C12.0536 6.58027 13.1002 6.76694 13.8536 7.26694C14.9069 7.96027 14.9069 9.10027 13.8602 9.80027Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29327 5.1787C4.33994 5.17203 4.38661 5.17203 4.43327 5.1787C5.46661 5.14536 6.28661 4.2987 6.28661 3.2587C6.28661 2.19203 5.42661 1.33203 4.35994 1.33203C3.29994 1.33203 2.43994 2.19203 2.43994 3.2587C2.43994 4.2987 3.25994 5.14536 4.29327 5.1787Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36674 8.56706C4.36674 9.21373 4.50674 9.82706 4.76008 10.3804C3.82008 10.4804 2.84008 10.2804 2.12008 9.80706C1.06674 9.10706 1.06674 7.96706 2.12008 7.26706C2.83341 6.78706 3.84008 6.59373 4.78674 6.70039C4.51341 7.26039 4.36674 7.89373 4.36674 8.56706Z",
    fill: "#292D32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08019 10.58C8.02686 10.5733 7.96686 10.5733 7.90686 10.58C6.68019 10.54 5.7002 9.53333 5.7002 8.29333C5.70686 7.02667 6.72686 6 8.0002 6C9.26686 6 10.2935 7.02667 10.2935 8.29333C10.2869 9.53333 9.31353 10.54 8.08019 10.58Z",
    fill: "#292D32"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9132 11.9617C4.90654 12.6351 4.90654 13.7417 5.9132 14.4084C7.05987 15.1751 8.93987 15.1751 10.0865 14.4084C11.0932 13.7351 11.0932 12.6284 10.0865 11.9617C8.94654 11.1951 7.06654 11.1951 5.9132 11.9617Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.d2cfc20d9d219831c65a875d0ead8000.svg";
export { ForwardRef as ReactComponent };